/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/23/20
 * Time: 2:26 PM
 */
/* eslint-disable*/
import {lang, language} from "./language";

export const BASE_ROUTE = "";
// export const BASE_ROUTE = "/";
export const ACCESS_TOKEN = "2d2c094";
export const REFRESH_TOKEN = "6c66b";
export const BASIC_AUTH = "c3R1ZGVudDo=";
export const VERIFY_CODE = "RtEw67ZUI6bg";
export const PAYMENT_TYPE = "bjRgjG893";
export const baseUrl = 'dXyf9veBgT';
export const classId = 'xyngGSU3Bv';
export const random = 'xysgGSUB3Bv';
export const start = 'KxCwDEYVzl';
export const meetingPassword = 'aJWRCOusyx';
// api service
export const VERIFY_USER_NOTE = "VERIFY_USER_NOTE";

export const ID = "v3un3mYVS0";
export const SIGNATURE = "nVzHYF8H0F";
export const USERNAME = "CBmYSJF1Gw";
export const PASSWORD = "HtIIWyeaWO";

// alert text
export const ALERT_TEXT = language[lang].AreYouSureYouWantToProceed;
export const ALERT_TEXT_VIDEO = language[lang].AreYouSureYouWantToProceedVideo;
export const DISABLE_YET = "Currently disabled this feature ...";

export const EXPIRED_TEXT = language[lang].SessionExpireNote;
export const GUEST_STUDENT_FOR_PURCHASE = language[lang].StudentSignInWarning;
export const GUEST_STUDENT_FOR_FREE = language[lang].StudentSignInWarning2;
export const GUEST_STUDENT_FOR_Register = language[lang].StudentSignInWarning2;
export const GUEST_STUDENT_FOR_CLASS_LESSON_PURCHASE = language[lang].StudentSignInWarningForClassLesson;
// export const PASSWORD_TEXT = "Password must contain at least 8 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS";
export const PASSWORD_TEXT = language[lang].PasswordText;

export const EXAM_ALERT = language[lang].AreYouSureYouWantToFinished;
export const EXAM_ANSWERS_ALERT = language[lang].deleteAnswer;

// route paths
export const AUTH_LOGIN_ROUTE = "/auth/login";
export const AUTH_REG_ROUTE = "/auth/register";
export const AUTH_FORGOT_ROUTE = "/auth/forgot-password";
export const HOME_ROUTE = "";

export const HOME_INSTITUTE_ROUTE = `${HOME_ROUTE}`;
export const HOME_TEACHER_ROUTE = `${HOME_ROUTE}/teacher`;
export const HOME_ALL_TEACHER_ROUTE = `${HOME_ROUTE}/all-teacher`;
export const HOME_COURSE_ROUTE = `${HOME_ROUTE}/courses`;
export const HOME_VIEW_COURSE_ROUTE = `${HOME_ROUTE}/view-course`;
export const HOME_MY_COURSE_ROUTE = `${HOME_ROUTE}/my-courses`;
export const HOME_MY_CLASS_ROUTE = `${HOME_ROUTE}/my-class`;
export const HOME_MY_LESSONS_ROUTE = `${HOME_ROUTE}/my-lessons`;
export const HOME_VIEW_CLASS_ROUTE = `${HOME_ROUTE}/view-class`;
export const HOME_VIEW_LECTURE_ROUTE = `${HOME_ROUTE}/view-lecture`;
export const HOME_VIEW_CLASS_ROUTE_PAYMENT = `${HOME_ROUTE}/pay-class`;
export const HOME_VIEW_LESSON_ROUTE = `${HOME_ROUTE}/lessons`;
export const HOME_VIEW_SELECTED_LESSON_ROUTE = `${HOME_ROUTE}/lessons-view`;
export const HOME_JOIN_CLASS_ROUTE = `${HOME_ROUTE}/join-class`;
export const HOME_JOIN_CLASS_URL_ROUTE = `${HOME_ROUTE}/join-class`;
export const JOIN_CLASSES = `${HOME_ROUTE}/join-classes`;
export const HOME_PROFILE_ROUTE = `${HOME_ROUTE}/profile`;
export const HOME_HELP_ROUTE = `${HOME_ROUTE}/help`;
export const HOME_PAYMENT_AUTHORIZE = `${HOME_ROUTE}/c7dfe8eaf9330773d4c5cf9b1ce74975`;
export const HOME_VIEW_PAPER_ROUTE = `${HOME_ROUTE}/papers`;
export const HOME_VIEW_SELECTED_PAPER_ROUTE = `${HOME_ROUTE}/paper-view`;
export const HOME_START_SELECTED_PAPER_ROUTE = `${HOME_ROUTE}/paper-start`;
export const HOME_START_ESSAY_SELECTED_PAPER_ROUTE = `${HOME_ROUTE}/essay-paper-start`;
export const FINISHED_PAPER_ROUTE = `${HOME_ROUTE}/paper-finished`;
export const HOME_VIEW_LEADERBOARD_ROUTE = `${HOME_ROUTE}/leader-board`;
export const HOME_COMPARE_ANSWERS_ROUTE = `${HOME_ROUTE}/compare-answers`;
export const HOME_GET_TEACHER_COMMENT_ROUTE = `${HOME_ROUTE}/getComment`;
export const HOME_EXAM_ROUTE = `${HOME_ROUTE}/exams`;
export const HOME_JOIN_CLASS_ERROR_ROUTE = `${HOME_ROUTE}/zoom-install`;
export const HOME_CERTIFICATES_ROUTE = `${HOME_ROUTE}/certificates`;
export const HOME_PREVIEW_CERTIFICATE_ROUTE = `${HOME_ROUTE}/certificate/`;

export const FREE_CLASS_DURATION = 14;


// payment type
export const SLIP_TYPE = 'SLIP';
export const CARD_TYPE = 'CARD';

// text
export const BOUGHT_TEXT = "BOUGHT";
export const BUY_TEXT = "BUY";
export const PENDING_TEXT = "PENDING";
export const RE_BUY_TEXT = "REPAY";

export const PURCHASE_STATUS = (str) => {
    switch (str) {
        case "BUY":
            return { name: "BUY", className: "buy-class" };
        case "BOUGHT":
            return { name: "BOUGHT", className: "bought-class" };
        case "PENDING":
            return { name: "PENDING", className: "pending-class" };
        default:
            return str;
    }
};

export const LAYOUT_OUT_01 = "LAYOUT_OUT_01";
export const LAYOUT_OUT_02 = "LAYOUT_OUT_02";

export const INSTITUTE = "INSTITUTE";
export const SINGLE_TEACHER = "SINGLE_TEACHER";
